import {h, Fragment} from "preact"
export default function IconGrid3 () {
    return (
        <svg aria-hidden="true" tabindex="-1" role="presentation" class="icon icon-one-third" viewBox="0 0 32 32"><path class="fill" d="M8.4,8.4H.1V0H8.4ZM20.2,0H11.8V8.4h8.4ZM31.9,0H23.6V8.4h8.3ZM8.4,11.8H.1v8.4H8.4Zm11.8,0H11.8v8.4h8.4Zm11.7,0H23.6v8.4h8.3ZM8.4,23.6H.1V32H8.4Zm11.8,0H11.8V32h8.4Zm11.7,0H23.6V32h8.3Z"></path></svg>
    )
}